export default {
    user: null,
    quote:null,    
    isLogged: false,        
    error: false,   
    isLoadingAuth: false,   
    permissions:[],    
    navigation:[],   
}